import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonAlertModalComponent } from './common-alert-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { PlaceholderReplacePipe } from 'src/app/shared/pipes/placeholder-replace/placeholder-replace.pipe';

@NgModule({
  declarations: [CommonAlertModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    PlaceholderReplacePipe
  ],
  exports: [CommonAlertModalComponent]
})
export class CommonAlertModalModule { }
